import { isTauriRuntime } from './runtime.ts'

type NativeFetchInit = RequestInit & {
  connectTimeout?: number
  maxRedirections?: number
}

export async function platformFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  if (!shouldUseNativeHttp(input)) return fetch(input, init)
  return nativeHttpFetch(input, init)
}

export async function nativeHttpFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const { fetch: nativeFetch } = await import('@tauri-apps/plugin-http')
  return nativeFetch(input, withNativeDefaults(init))
}

export function isPlatformFetchAbortError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') return true
  return error instanceof Error && error.message === 'Request cancelled'
}

function shouldUseNativeHttp(input: RequestInfo | URL): boolean {
  if (!isTauriRuntime()) return false

  const url = requestUrl(input)
  return /^https?:\/\//i.test(url)
}

function requestUrl(input: RequestInfo | URL): string {
  if (input instanceof Request) return input.url
  if (input instanceof URL) return input.href
  return String(input)
}

function withNativeDefaults(init: RequestInit): NativeFetchInit {
  return {
    connectTimeout: 30000,
    ...init,
  }
}
